import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { useStyles } from "./style";

export default function TopItem({ item }) {
  const classes = useStyles();
  return (
    <>
      <div className={classes.item}>
        <div className={classes.imgContainer}>
          <span className={classes.vs}>VS</span>
          <img src={item.first.img} className={classes.img} />
          <img src={item.second.img} className={classes.img} />
        </div>
        <div style={{ padding: "10px", marginTop: "5px" }}>
          <p className={classes.text}>{item.first.name}</p>
          <p className={classes.text}>vs</p>
          <p className={classes.text}>{item.second.name}</p>
        </div>
      </div>
    </>
  );
}
